import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export async function logout(): Promise<undefined | void> {
  try {
    const promise = await client.post('/auth/logout');

    const { data } = promise;
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}`);
    }
  }
}

export const useLogoutUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSettled: () => {
      queryClient.resetQueries({ queryKey: ['auth', 'session'] });
    },
  });
};
